<template>
  <b-card header="Trade Information" style="width: 500px;">
    <div
      style="display: grid; grid-template-columns: repeat(2, 1fr); grid-template-rows: repeat(3, 1fr); grid-gap: 0.75rem;"
    >
      <b-form-group label="Entity Type" style="grid-column: 1/3;">
         <b-form-select v-model="company.businessEntityType" >
          <option
            v-for="corporateType in corporateTypes"
            :key="corporateType.id"
            :value="corporateType.id"
          >{{ corporateType.name }}</option>
        </b-form-select>
      </b-form-group>
      <b-form-group label="Tax ID">
        <b-form-input v-model="company.taxEIN"></b-form-input>
      </b-form-group>
      <b-form-group label="State of Incorporation">
        <b-form-select v-model="company.stateOfIncorporation" >
          <option
            v-for="state in corporateStates"
            :key="state.stateName"
            :value="state.stateName" 
          >{{ state.stateName }}</option>
        </b-form-select>
      </b-form-group>
      <b-form-group label="Dun & Bradstreet" style="grid-column: 1/3;">
        <b-form-input v-model="company.dunsNumber"></b-form-input>
      </b-form-group>
     <b-form-group style="grid-column: 1/3; text-align:right">
       <button
            data-v-5755921e
            type="button"
            class="btn mr-2 button-menu btn-secondary btn-sm"  
            :disabled="isCorporateDetailsValid"
            @click="saveCorporateDetail"
          >SAVE</button>
     </b-form-group>
      </div>
  </b-card>
</template>
<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
export default {
  props: ['companyId'],

  computed: {
    ...mapState('companies', ['corporateTypes','corporateStates']),
    ...mapState('companies', ['company']),

    isCorporateDetailsValid(){
      return(
        this.company.businessEntityType === null 
          );
    }
  },
  methods: {
    ...mapActions('companies', ['getCorporateType','getCorporateState']),
    ...mapActions('companies', ['saveCorporateDetails']),

    async getCorporateTypeData() {
      await this.getCorporateType();
    },
    async getCorporateStateData() {
      await this.getCorporateState();
    },
     saveCorporateDetail(){
       this.saveCorporateDetails();
    }
  },
  created() {
    this.getCorporateTypeData();
    this.getCorporateStateData();
  }
};
</script>